import { render, staticRenderFns } from "./presentation-chart.vue?vue&type=template&id=0797761b&"
import script from "./presentation-chart.vue?vue&type=script&lang=js&"
export * from "./presentation-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0797761b')) {
      api.createRecord('0797761b', component.options)
    } else {
      api.reload('0797761b', component.options)
    }
    module.hot.accept("./presentation-chart.vue?vue&type=template&id=0797761b&", function () {
      api.rerender('0797761b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/presentation-chart.vue"
export default component.exports